import moment from "moment"
import { useAiTeammateContext } from "../../hooks/context"
import "./style.scss"

export default function AiTeammateHeaderMetadata() {
  const { resourceMetadata, benchmarkMetadata, modelMetadata, startDate, endDate } = useAiTeammateContext()

  const formattedStartDate = moment(startDate).format("ll")
  const formattedEndDate = moment(endDate).format("ll")

  return <div className="ai-teammate-header-metadata">
    <div className="info-item">
      <span className="label">Resource:</span>
      <span className="value">{resourceMetadata?.name || "Unknown Resource"}</span>
    </div>
    {benchmarkMetadata && <div className="info-item">
      <span className="label">Benchmark:</span>
      <span className="value">{benchmarkMetadata.name}</span>
    </div>}
    <div className="info-item">
      <span className="label">Model:</span>
      <span className="value">{modelMetadata?.name || "Unknown Model"}</span>
    </div>
    {startDate && endDate && <div className="info-item">
      <span className="label">Period:</span>
      <span className="value">{formattedStartDate} - {formattedEndDate}</span>
    </div>}
  </div>
}
